import styled from 'styled-components'

export const Container = styled.div`
  .ant-incomatibilidade {
    .ant-tabs-nav-wrap {
      background-color: #ec2222;
    }

    .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab {
      background-color: #ec2222ff;
      color: #ffffff;
      border: none;
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: #ec2222ff !important;
    }

    .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab.ant-tabs-tab-active {
      background-color: #ffffff;
    }

    .ant-tabs-content {
      margin-left: 15px;
      margin-right: 15px;
    }
  }
`
